import createMessages from 'mz-intl/create';

export default createMessages('WAITING_TIME', {
  FREE_WAIT: 'Free Wait',
  WAITING_FROM_AIRPORT: 'waiting time from airport',
  WAITING_FROM_PORT: 'waiting time from port',
  WAITING_FROM_STATION: 'waiting time from train station',
  WAITING_FROM_LOCATION: 'waiting time from other location'
});
